export const LS_REDIRECT_TO = 'loginRedirectTo'; // Match ZB.com key
export const LS_LOGIN_STATE = 'auth0StateValue';
export const LS_ID_TOKEN = 'id_token';
export const LS_ACCESS_TOKEN = 'access_token';
export const LS_EMAIL = 'loggin_in_email';
export const LS_ACCOUNT_UUID = 'accountUUID';
export const LS_OBO = 'obo';
export const LS_USER_PROFILE = 'auth0_profile';
export const LS_WEBVIEW_DATA = 'webViewSessionData';

// LEGACY KEYS
export const LS_CREATION_DATE = 'creation_date';
export const LS_FIRST_NAME = 'first_name';
export const LS_LAST_NAME = 'last_name';
export const LOCALSTORAGE_KEYS = {
  REDIRECT_TO: LS_REDIRECT_TO,
  LOGIN_STATE: LS_LOGIN_STATE,
  ID_TOKEN: LS_ID_TOKEN,
  ACCESS_TOKEN: LS_ACCESS_TOKEN,
  EMAIL: LS_EMAIL,
  ACCOUNT_UUID: LS_ACCOUNT_UUID,
  OBO: LS_OBO,
  USER_PROFILE: LS_USER_PROFILE,
  CREATION_DATE: LS_CREATION_DATE,
  FIRST_NAME: LS_FIRST_NAME,
  LAST_NAME: LS_LAST_NAME,
  WEBVIEW_DATA: LS_WEBVIEW_DATA
};

/**
 * Minutes to extend a session.
 * We can only extend once per 15 minutes, per Auth0 limitation on checkSession call.
 *
 * @type {number}
 * @private
 */
export const EXTEND_DURATION_MINUTES = 15;
export const PROFILE_PAYLOAD_KEY = 'https://www.zenbusiness.com/profile';